export const getHasExceededContactLimit = (input: {
    hasUnlimitedMarketingContacts: boolean;
    marketingContactsOverageAllowance: number | null | undefined;
    numberOfMarketableContacts: number;
    maxNumberOfMarketableContacts: number | null | undefined;
}): boolean => {
    const {
        hasUnlimitedMarketingContacts,
        marketingContactsOverageAllowance,
        numberOfMarketableContacts,
        maxNumberOfMarketableContacts,
    } = input;

    if (hasUnlimitedMarketingContacts) {
        return false;
    }

    if (marketingContactsOverageAllowance && marketingContactsOverageAllowance > 1) {
        return numberOfMarketableContacts > marketingContactsOverageAllowance;
    }

    if (maxNumberOfMarketableContacts) {
        return numberOfMarketableContacts > maxNumberOfMarketableContacts;
    }

    return false;
};

export const getRemainingSends = (input: {
    maxNumberOfEmailsPerMonth: number | null | undefined;
    numberOfEmailsSentThisMonth: number;
}): number | null | undefined => {
    const {maxNumberOfEmailsPerMonth, numberOfEmailsSentThisMonth} = input;

    return maxNumberOfEmailsPerMonth
        ? maxNumberOfEmailsPerMonth - numberOfEmailsSentThisMonth
        : undefined;
};
